import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';
import { tween } from 'shifty/dist/shifty.core';

when($('helptab'), function (el) {
   let tabInit = function () {
      TweenMax.to(el, 0.6, {
         right: -95,
         ease: Bounce.easeOut,
      });
   };

   tabInit.delay(1000);
   el.addEvents({
      mouseenter: function () {
         tween({
            from: { right: -95 },
            to: { right: -40 },
            duration: 200,
            render: ({ right }) => {
               el.style.right = `${right}px`;
            },
         });
      },
      mouseleave: function () {
         tween({
            from: { right: -40 },
            to: { right: -95 },
            duration: 200,
            render: ({ right }) => {
               el.style.right = `${right}px`;
            },
         });
      },
      click: function () {
         trackInMatomoAndGA({
            eventCategory: 'Help Tab',
            eventAction: 'Click',
         });
         return true;
      },
   });
});
